import React, { useState } from 'react'
import classNames from 'classnames'
import { toast } from 'react-toastify'

import Button from '../Button/Button'
import TextField from '../TextField/TextField'

import { httpPost } from '../../services/http'

import { UKRAINE_PHONE_NUMBER_REG_EXP } from '../../constants/regexp.constants'

import './questions-remain.css'

const QuestionsRemain = ({ className, children }) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [phoneFieldTouched, setPhoneFieldTouched] = useState(false)

  const addQuestion = () => {
    toast.success('Ваше питання відправлено!')
    httpPost('question/add', {
      name,
      phone
    })
    setName('')
    setPhone('')
  }

  return (
    <section className={classNames('questions-remain', className)}>
      <div className='section__content'>
        {children}
        <div className='questions-remain__top'>
          <div className='questions-remain__top__title'>Залишились питання?</div>
          <div className='questions-remain__top__sub-title'>Заповніть форму і ми зв'яжемося з вами, найближчим часом</div>
        </div>
        <div className='questions-remain__bottom'>
          <TextField
            placeholder="Ваше ім'я"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            type='phone'
            placeholder='Ваш телефон без (+38)'
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value)
              setPhoneFieldTouched(true)
            }}
            isInvalid={phoneFieldTouched && !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP)}
            errorText='Не валідний телефон'
          />
          <Button
            onClick={addQuestion}
            disabled={!name || !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP)}
          >
            Залишити заявку
          </Button>
        </div>
      </div>
    </section>
  )
}

export default QuestionsRemain
